// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1DlQN","errors":"Errors_errors__HCTkz"};